import React from "react";
import { Modal, Spin, Button } from "antd";
import Gradient from "../assets/svg/Gradient.svg";

const SpiningModal = ({
  open,
  handleCancel,
  zIndex = 10000,
  currentAttempt = 0,
  maxAttempts = 6,
  onManualCheck,
  isTimedOut = false,
  isChecking = false,
  c2bConfirmed = false,
}) => {
  const attemptsRemaining = maxAttempts - currentAttempt;
  const secondsRemaining = attemptsRemaining * 10;

  return (
    <>
      <Modal
        open={open}
        onCancel={handleCancel}
        width="30rem"
        footer={null}
        closeIcon={null}
        className="electricity-modal"
        zIndex={zIndex}
        styles={{
          body: {
            position: "relative",
            height: "30rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundImage: `url(${Gradient})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right",
            backgroundSize: "100% auto",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />
        <div className="flex flex-col items-center text-center">
          {!isTimedOut ? (
            <>
              {c2bConfirmed ? (
                <>
                  <div className="w-[3rem] h-[3rem] rounded-full bg-[#D9F9E6] flex items-center justify-center mb-[1rem]">
                    <span className="text-[#2F9461] text-[1.5rem]">✓</span>
                  </div>
                  <div className="text-[1.125rem] font-[500] text-[#2F9461] mb-[0.5rem]">
                    M-Pesa Payment Received
                  </div>
                  <div className="text-[0.875rem] text-[#64748B] mb-[1rem]">
                    Waiting for KPLC to generate your token...
                  </div>
                  <Spin className="sms-spin mb-[1.5rem]" />
                  <div className="text-[0.75rem] text-[#94A3B8]">
                    This may take a few moments
                  </div>
                </>
              ) : (
                <>
                  <div className="text-[1.125rem] font-[500] text-[#0F172A] mb-[0.5rem]">
                    Waiting for payment confirmation
                  </div>
                  <div className="text-[0.875rem] text-[#64748B] mb-[1rem]">
                    Checking payment status...
                  </div>
                  <Spin className="sms-spin mb-[1.5rem]" />
                  <div className="text-[0.875rem] text-[#64748B]">
                    Attempt {currentAttempt} of {maxAttempts}
                  </div>
                  <div className="text-[0.75rem] text-[#94A3B8] mt-[0.25rem]">
                    {secondsRemaining > 0 ? `~${secondsRemaining} seconds remaining` : "Finalizing..."}
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <div className="text-[1.125rem] font-[500] text-[#0F172A] mb-[0.5rem]">
                Payment status check timed out
              </div>
              <div className="text-[0.875rem] text-[#64748B] mb-[1.5rem]">
                We couldn't confirm your payment automatically. You can try checking manually or contact support.
              </div>
              <Button
                type="primary"
                onClick={onManualCheck}
                loading={isChecking}
                className="!bg-[#2F9461] !border-[#2F9461] !h-[2.5rem] !px-[1.5rem] !rounded-[0.5rem] mb-[1rem]"
              >
                {isChecking ? "Checking..." : "Check Payment Status"}
              </Button>
              <Button
                type="default"
                onClick={handleCancel}
                className="!h-[2.5rem] !px-[1.5rem] !rounded-[0.5rem]"
              >
                Close
              </Button>
            </>
          )}
        </div>
      </Modal>
    </>
  );
};
export default SpiningModal;
